import { css } from 'styled-components';

export const checkboxBoxStyles = css`
  width: 20px;
  height: 20px;
  background: white;
  border: 1px solid #1f1f1f;
  border-radius: 3px;
`;

export const checkboxTickStyles = css`
  content: '';
  position: absolute;
  width: 7px;
  height: 14px;
  border: solid black;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
`;
